<template>
    <b-modal :id="modalId" size="xl" hide-footer>
        <div class="d-flex flex-column gap-3">

            <DataTable
                :fields="fields1"
                :items="requestHistory.getData(id) || []"
                :error="requestHistory.getError(id)"
                :loading="requestHistory.getLoading(id)"
                :header="$t('feedProcessingHistory')"
                sort-by="date"
                sort-direction="desc"
            >
                <template #cell(successful)="{value}">
                    <BadgeBoolean :value="value" />
                </template>
                <template #cell(finishedAt)="{value}">
                    <template v-if="value">{{ dateFormat(value, 'yyyy-MM-dd HH:mm:ss') }}</template>
                </template>
            </DataTable>

            <DataTable
                :fields="fields2"
                :items="requestDeactivationReports.getData(id) || []"
                :error="requestDeactivationReports.getError(id)"
                :loading="requestDeactivationReports.getLoading(id)"
                :header="$t('offersDeactivationHistory')"
                sort-by="date"
                sort-direction="desc"
            >
                <template #cell(date)="{value}">
                    <template v-if="value">{{ dateFormat(value, 'yyyy-MM-dd HH:mm:ss') }}</template>
                </template>
            </DataTable>

        </div>
    </b-modal>
</template>



<script>
    import { format as dateFormat } from 'date-fns';
    import DataTable from '@/components/common/DataTable.vue';
    import BadgeBoolean from '@/components/common/BadgeBoolean.vue';

    export default {
        name: 'FeedModalDetails',
        components: {
            DataTable,
            BadgeBoolean,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestHistory: this.$req('productFeeds/History'),
                requestDeactivationReports: this.$req('productFeeds/DeactivationReports'),
                id: 0,
            };
        },
        computed: {
            modalId() {
                return this.parentComponent.modalDetailsId;
            },
            fields1() {
                return [
                    { key: 'id', label: this.$t('id') },
                    { key: 'feedId', label: this.$t('feedId') },
                    { key: 'finishedAt', label: this.$t('processedAt') },
                    { key: 'offersNo', label: this.$t('offersNumber') },
                    { key: 'message', label: this.$t('message') },
                    { key: 'successful', label: this.$t('successful') },
                ];
            },
            fields2() {
                return [
                    { key: 'id', label: this.$t('id') },
                    { key: 'productFeed', label: this.$t('productFeed') },
                    { key: 'date', label: this.$t('date') },
                    { key: 'offersNo', label: this.$t('offersNumber') },
                ];
            },
        },
        watch: {
            id() {
                if (this.id) this.fetchData();
            },
        },
        methods: {
            dateFormat,
            setId(id) {
                this.id = id;
            },
            fetchHistory() {
                this.requestHistory
                    .id(this.id)
                    .get({ urlParams: { id: this.id } })
                    .catch(() => {});
            },
            fetchDeactivationReports() {
                this.requestDeactivationReports
                    .id(this.id)
                    .get({ urlParams: { id: this.id } })
                    .catch(() => {});
            },
            fetchData() {
                this.fetchHistory();
                this.fetchDeactivationReports();
            },
        },
        mounted() {
            this.$root.$on(this.modalId, this.setId);
        },
        beforeDestroy() {
            this.$root.$off(this.modalId, this.setId);
        },
    };
</script>
